module.exports = __webpack_public_path__ + "static/media/kayfik_logo_arabic.1a696bae.jpg";